import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyboardArrowDown, Menu, Close } from "@mui/icons-material";

export default function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  return (
    <nav className="font-serif bg-blue-500 text-white px-4 py-4">
      <div className="flex items-center justify-between">
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-16 md:pl-50  text-sm font-light uppercase tracking-wider">
          <Link to="/" className="hover:text-amber-500">
            HOME
          </Link>

          <div className="relative group">
            <button className="hover:text-amber-500 flex items-center">
              LOANS <KeyboardArrowDown />
            </button>
            <div className="absolute hidden group-hover:block bg-white text-gray-800 shadow-lg mt-1 rounded border-amber-500 w-48 z-10">
              <Link
                to="/apply-loan"
                className="block px-4 py-2 hover:bg-gray-100 hover:text-amber-500"
              >
                Car Loan
              </Link>
              <Link
                to="/apply-loan"
                className="block px-4 py-2 hover:bg-gray-100 hover:amber-500"
              >
                Asset Loan
              </Link>
            </div>
          </div>

          <Link to="/loan-calculator" className="hover:text-amber-500">
            LOAN CALCULATOR
          </Link>
          <Link to="/about-us" className="hover:text-amber-500">
            ABOUT US
          </Link>
          <Link to="/faqs" className="hover:text-amber-500">
            FAQS
          </Link>
          <Link to="/contact-us" className="hover:text-amber-500">
            CONTACT US
          </Link>
        </div>

        {/* Mobile Menu Toggle Button */}
        <button
          className="md:hidden text-white focus:outline-none ali"
          onClick={toggleMenu}
        >
          {isMobileMenuOpen ? <Close /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mt-4 space-y-2 text-sm font-light uppercase tracking-wider md:hidden text-left">
          <Link
            to="/"
            className="block hover:text-amber-500"
            onClick={toggleMenu}
          >
            HOME
          </Link>

          <div>
            <p className="text-white font-medium">LOANS</p>
            <div className="pl-4 space-y-1">
              <Link
                to="/apply-loan"
                className="block hover:text-[#ffc300]"
                onClick={toggleMenu}
              >
                Personal Loan
              </Link>
              <Link
                to="/apply-loan"
                className="block hover:text-[#ffc300]"
                onClick={toggleMenu}
              >
                Business Loan
              </Link>
            </div>
          </div>

          <Link
            to="/loan-calculator"
            className="block hover:text-[#ffc300]"
            onClick={toggleMenu}
          >
            LOAN CALCULATOR
          </Link>
          <Link
            to="/about"
            className="block hover:text-[#ffc300]"
            onClick={toggleMenu}
          >
            ABOUT US
          </Link>
          <Link
            to="/faqs"
            className="block hover:text-[#ffc300]"
            onClick={toggleMenu}
          >
            FAQS
          </Link>
          <Link
            to="/contact"
            className="block hover:text-[#ffc300]"
            onClick={toggleMenu}
          >
            CONTACT US
          </Link>
        </div>
      )}
    </nav>
  );
}
